export default __webpack_public_path__ + "static/media/Askeladden1.e75357e9.jpg";